import { Controller } from '@hotwired/stimulus';
import EmblaCarousel, { type EmblaCarouselType } from 'embla-carousel';

/**
 * イベント詳細カルーセルを制御するコントローラ
 */
export default class extends Controller<HTMLElement> {
  static override targets = ['viewport', 'thumbViewport', 'thumb', 'copyright'];

  declare readonly viewportTarget: HTMLElement;
  declare readonly thumbViewportTarget: HTMLElement;
  declare readonly thumbTargets: HTMLElement[];
  declare readonly copyrightTarget: HTMLElement;
  declare readonly hasCopyrightTarget: boolean;

  private emblaApi!: EmblaCarouselType;
  private emblaThumbsApi!: EmblaCarouselType;
  private images: Array<{ path: string; copyright: string }> = [];

  override connect() {
    this.loadImages();
    this.initializeCarousel();
  }

  override disconnect() {
    if (this.emblaApi) {
      this.emblaApi.destroy();
    }
    if (this.emblaThumbsApi) {
      this.emblaThumbsApi.destroy();
    }
  }

  private loadImages() {
    const dataValue = this.element.dataset.images;
    if (dataValue) {
      try {
        this.images = JSON.parse(dataValue);
      } catch (e) {
        console.error('Failed to parse images data:', e);
      }
    }
  }

  private initializeCarousel() {
    const viewport = this.viewportTarget as HTMLElement;
    const thumbViewport = this.thumbViewportTarget as HTMLElement;

    this.emblaApi = EmblaCarousel(viewport, {
      loop: false,
      align: 'start',
      containScroll: 'trimSnaps',
    });

    this.emblaThumbsApi = EmblaCarousel(thumbViewport, {
      containScroll: 'keepSnaps',
      dragFree: true,
    });

    this.emblaThumbsApi.slideNodes().forEach((thumbNode, index) => {
      const button = thumbNode as HTMLButtonElement;
      button.addEventListener('click', () => {
        if (this.emblaApi) {
          this.emblaApi.scrollTo(index);
        }
      });
    });

    this.emblaApi.on('select', () => {
      if (this.emblaApi && this.emblaThumbsApi) {
        this.emblaThumbsApi.scrollTo(this.emblaApi.selectedScrollSnap());
      }
      this.updateCopyright();
    });
  }

  private updateCopyright() {
    if (this.emblaApi && this.hasCopyrightTarget && this.images.length > 0) {
      const currentIndex = this.emblaApi.selectedScrollSnap();
      const currentImage = this.images[currentIndex];
      if (currentImage) {
        this.copyrightTarget.textContent = currentImage.copyright || '';
      }
    }
  }
}
